import React, { memo } from 'react';

import Symbol from '@/components/atomic/atoms/data-display/icons/symbol';
import IconNames from '@/components/atomic/atoms/data-display/icons/symbol/enum';
import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';

const IconSliceComponent: React.FC<BasicComponentProps> = ({
	$exposerSuffix,
}) => (
	<Symbol
		$exposerSuffix={$exposerSuffix}
		id={IconNames.FIND_A_RETAILER}
		viewBox={[0, 0, 24, 24]}
		dangerouslySetInnerHTML={{
			__html: '<circle cx="12" cy="9" r="3"></circle><path d="M12,0C7,0,3,4,3,9c0,2.8,1.3,5.5,3.6,7.2L9,18c1.3,0.9,2,2.4,2,4v1c0,0.6,0.4,1,1,1s1-0.4,1-1v-1      c0-1.6,0.7-3.1,2-4l2.4-1.8c4-3,4.8-8.6,1.8-12.6C17.5,1.3,14.8,0,12,0z M15.6,15l-3.1,1.9c-0.3,0.2-0.7,0.2-1,0L8.4,15      C5.1,13,4,8.7,6,5.4S12.3,1,15.6,3S20,9.3,18,12.6C17.4,13.6,16.6,14.4,15.6,15z"></path>',
		}}
	/>
);

const IconSlice = memo(
	withExposer(IconSliceComponent, 'iconSlice_FIND_A_RETAILER'),
);

export default IconSlice;
